import http from '@/utils/http' //引入axios
export const getMenu = data => http.get('/user-center/api/menu', {
  params: data
}) //查找部菜单
export const updataMenu = data => http.put('/user-center/api/menu', data) //編輯菜单
export const addMenu = data => http.post('/user-center/api/menu', data) //添加菜单
export const deleteMenu = data => http.delete('/user-center/api/menu', {
  params: data
}) //刪除菜单
export const findMenu = data => http.get('/user-center/api/menu/superior', {
  params: data
}) //根据ID查询菜单信息
export const getMenus = () => http.get('/user-center/api/menu/build') //根据用户id查找菜单
export const exportMenu = data => http.get('/user-center/api/menu/excel', {
  params: data,
  responseType: 'blob'
})
// 角色列表查询全部菜单
export const getAllMenus = data => http.get('/user-center/api/menu/allMenu', {
  params: data
})
export default {
  getMenu,
  updataMenu,
  addMenu,
  deleteMenu,
  findMenu,
  getMenus,
  exportMenu,
  getAllMenus
}